/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="">
      <div class="margin-b-zero mdl-cell mdl-cell--12-col">
        <div class="listing-table-container" style="border:2px solid #f6f8f9;border-radius: 5px;">
          <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
            <div class="mdl-cell--12-col">
              <div class="listing-filter-actions light-background" style="margin-bottom:2px;">
                  <div class="filter-container">
                      <div class="horizontal layout content-align-vertical-center list-search">
                          <div class="mdl-cell--4-col mdl-cell--8-col-tablet margin-t-zero margin-b-zero">
                              <div class="mdl-cell mdl-cell--12-col tbl-action-category-text-search  secondary-color" >
                                  <oe-i18n-msg class="category-text font-14 secondary-color" style = "margin-left:8px;" msgid="l_Search"></oe-i18n-msg>
                              </div>
                              <list-search class="searchheight search-box" tabindex=0 data="{{accountsList}}" filter-val={{filterVal}} fields="{{filterTransactions}}" id="transactionsListsearch"></list-search>
                          </div>
                      </div>
                  </div>
              </div>
              <div id="list-container" role="table">
                  <div class="content-align-vertical-center margin-b-zero mdl-grid horizontal layout font-10 secondary-color text-transform-uppercase font-weight-700" style="padding:1.2%;background-color:#FAFAFB;">   
                      <div class="mdl-cell mdl-cell--1-col">
                          <paper-checkbox id="checkbox-selectall" class="selection-checkbox" on-change="_checkUncheckAll" checked={{checkAll}} hidden="{{!_isShowTable(displayRows)}}"></paper-checkbox>
                      </div>
                      <div class="mdl-cell mdl-cell--4-col">
                          <oe-i18n-msg class="acct-list-header-class" msgid="l_AccountName"></oe-i18n-msg>
                      </div>
                      <div class="mdl-cell mdl-cell--4-col">
                          <oe-i18n-msg class="acct-list-header-class" msgid="l_Account_Num"></oe-i18n-msg>
                      </div>
                      <div class="mdl-cell mdl-cell--3-col">
                          <oe-i18n-msg class="acct-list-header-class" msgid="l_Accounttype"></oe-i18n-msg>
                      </div>
                  </div>
                  <template is="dom-if" if="{{accountsListLoaded}}">
                      <template is="dom-if" if="[[_isShowTable(displayRows)]]">
                          <template is = "dom-repeat" items="{{displayRows}}">
                              <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px">
                                  <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                                      <div class="mdl-cell mdl-cell--1-col acct-list-value-class wrapClass1">
                                        <paper-checkbox id="checkbox" class="selection-checkbox" on-change="_checkUncheck" checked$={{item.selected}}></paper-checkbox>
                                      </div>
                                      <div class="mdl-cell mdl-cell--4-col-desktop acct-list-value-class wrapClass1" role="cell">
                                          {{item.accountName}}
                                      </div>
                                      <template is="dom-if" if="{{!_isCards(item)}}">
                                        <div class="mdl-cell mdl-cell--4-col-desktop acct-list-value-class wrapClass1" role="cell">
                                            {{item.accountId}}
                                        </div>
                                      </template>
                                      <template is="dom-if" if="{{_isCards(item)}}">
                                        <div class="mdl-cell mdl-cell--4-col-desktop acct-list-value-class wrapClass1" role="cell">
                                          </iron-icon> {{_formatCreditCard(item.accountId)}}
                                        </div>
                                      </template>
                                      <div class="mdl-cell mdl-cell--3-col-desktop acct-list-value-class wrapClass1" role="cell">
                                          {{item.accountType.codeDescription}}
                                      </div>
                                  </div>
                          </template>
                      </template>
                      <template is="dom-if" if="[[!_isShowTable(displayRows)]]">
                          <div class="mdl-grid mdl-cell light-background full-width content-align-center margin-zero">
                              <supporting-msg icon-name="no_txn" background="" title-msg="l_noRecrdFound"></supporting-msg>
                          </div>
                      </template>
                  </template>
                  <template is="dom-if" if="{{!accountsListLoaded}}">
                      <paper-card class="full-width" elevation="0">
                          <div class="content-align-center light-background spinner-innder-div text-align-center">
                              <paper-spinner active></paper-spinner>
                          </div>
                      </paper-card>
                  </template>
              </div>
              <div class="pagination-margin">
                  <oe-data-table-custom-pagination rows-data="{{accountsList}}" display-rows = "{{displayRows}}">
                  </oe-data-table-custom-pagination>
              </div>
          </div>
        </div>
      </div>
    `;
Polymer({
  is: 'open-banking-account-common-listing',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow],
  properties: {
    accountsList: {
      type: Array,
      notify: true,
      value: []
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    accountsListLoaded: {
      type: Boolean,
      value: false
    },
    displayRows: {
      type: Array,
      notify: true,
      observer: "_displayRowsUpdated"
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    filterVal: {
      type: String,
      value: ""
    },
    filterTransactions: {
      type: Array,
      notify: true,
      value: ['accountName', 'accountId', 'accountType.codeDescription']
    },
    selectedAccountList: {
      type: Array,
      value: [],
      notify: true
    }
  },
  getExpiryLabel() {
    return getLabel("l_accountAccessExpiry") + this.formatDate(this.openBankingConsentResponse.transactionToDate);
  },
  formatDate: function (date) {
    return moment.utc(date).format('DD-MMM-YYYY');
  },
  _checkUncheck: function (e) {
    var index = e.model.__data.index;
    var accountId = this.displayRows[index].accountId;
    if (e.currentTarget.checked) {
      this.set('displayRows.' + index + '.selected', true);
      if (this.selectedAccountList.indexOf(accountId) === -1) {
        this.selectedAccountList.push(accountId);
      }
      var count = 0;
      for (var index = 0; index < this.displayRows.length; index++) {
        if (this.displayRows[index].selected) {
          count++;
        }
      }
      if (this.displayRows.length == count) {
        this.checkAll = true;
      }
    } else {
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.forEach((item, index) => {
          if (item == accountId) {
            this.selectedAccountList.splice(index, 1);
          }
        });
      }
      this.set('displayRows.' + index + '.selected', false);
      this.checkAll = false;
    }
    e.stopPropagation();
  },
  _checkUncheckAll(event) {
    this.checkAll = event.currentTarget.checked;
    if (this.checkAll) {
      for (var index = 0; index < this.displayRows.length; index++) {
        this.set('displayRows.' + index + '.selected', true);
        if (this.selectedAccountList.indexOf(this.displayRows[index].accountId) === -1) {
          this.selectedAccountList.push(this.displayRows[index].accountId);
        }
      }
    }
    else {
      for (var index = 0; index < this.displayRows.length; index++) {
        this.set('displayRows.' + index + '.selected', false);
      }
      if (this.selectedAccountList && this.selectedAccountList.length > 0) {
        for (var i = 0; i < this.displayRows.length; i++) {
          for (var k = 0; k < this.selectedAccountList.length; k++) {
            if (this.displayRows[i].accountId == this.selectedAccountList[k]) {
              this.selectedAccountList.splice(k, 1);
            }
          }
        }
      }
    }
    event.stopPropagation();
  },
  _displayRowsUpdated() {
    if (this.displayRows && this.displayRows.length > 0) {
      var count = 0;
      for (var index = 0; index < this.displayRows.length; index++) {
        if (this.displayRows[index].selected) {
          count++;
        }
      }
      if (this.displayRows.length == count) {
        this.checkAll = true;
      }
      else {
        this.checkAll = false;
      }
    }
    else {
      this.checkAll = false;
    }
  },
  _cardType(cardIssuer) {
    var cardType = 'MASTER';
    if (cardIssuer === 'VISA') {
      cardType = 'VISA';
    };
    return cardType;
  },
  _isCards(item) {
    if (item.parentAccountType.cmCode == "CCD" || item.accountType.cmCode == "PCD") {
      return true;
    }
    return false;
  }
});
